import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./SubscriptionProductsForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelChangeSubscriptionProducts} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {validateGreaterThan} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validateGreaterThan(errors, values, "frequencyWeeks", 0);
  // At least 1 product needs to have quantity above 0.
  // Products with 0 will be removed before sending.
  if (values.get("products", Map()).every((value, key) => value.get("quantity") === 0)) {
    errors = errors.set("products", Map({_error: "At least one product must have a quantity."}));
  }
  return errors.toJS();
}

class ChangeSubscriptionProductsFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: []}
  }

  handleSubmit(values) {
    let products = 
      // Filter only products with a quantity.
      values.get("products").filter(x => x.get("quantity"))
            .map(x => {
                // Only send productSku and quantity
                return Map({
                  productSku: x.get("productSku"),
                  quantity: x.get("quantity")
                })
              });

    let updatedValues = 
      values.set("subscriptionId", this.props.subscriptionId)
            .set("products", products);
                              
    return this.props.changeSubscription(updatedValues.toJS())
      .then((response) => {
        if (response.data.changeSubscription.errors.length <= 0) {
          this.props.cancelChangeSubscriptionProducts();
        } else {
          let errors = createValidationErrors(response.data.changeSubscription.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeSubscriptionProducts();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    const subscribeable = fromJS(data.subscriptionSubscribeableProducts);
    const info = fromJS(data.subscriptionInfo);
    // Map items.
    let mapped = info.get("products").reduce((acc, x) => {
      return acc.set(x.get("productSku"), x.get("quantity")) 
    }, Map());
    // Go through each subscribeable and add either quantity or 0.
    let products = subscribeable.map(x => {
      return x.set("quantity", mapped.get(x.get("productSku"), 0));
    })

    let initialValues = Map({
      frequencyWeeks: info.get("frequencyWeeks"),
      products: products
    });

    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const GET_SUBSCRIPTION = gql`
  query subscriptionInfo($subscriptionId: ID!) {
    subscriptionInfo(subscriptionId: $subscriptionId) {
      products {
        productSku
        productTitle
        quantity
      }
      frequencyWeeks
    }
    subscriptionSubscribeableProducts(subscriptionId: $subscriptionId) {
      productSku
      productTitle
    }
  }
`;

const CHANGE_SUBSCRIPTION = gql`
  mutation changeSubscription($data: ChangeSubscriptionInput!) {
    changeSubscription(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(GET_SUBSCRIPTION, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        subscriptionId: props.subscriptionId
      }
    })
  }),
  graphql(CHANGE_SUBSCRIPTION, {
    props: ({ mutate }) => ({
      changeSubscription: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const ChangeSubscriptionProductsFormContainerWithData = withProductQuery(ChangeSubscriptionProductsFormContainer);

export default connect(null, {cancelChangeSubscriptionProducts})(ChangeSubscriptionProductsFormContainerWithData);